module.exports = __webpack_public_path__ + "static/media/album.6d7400aa.jpeg";